module.exports = __webpack_public_path__ + "img/matthieu.a72bb257.png";